


















































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import {
  VehicleReviveSteps,
  StepsJson,
  Owners,
  VehicleReviveStepsViewModel,
  LaborOpCodes,
  StepInspectionForm,
} from '@/models/inventory/vehiclerevivesteps';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {vehicleReviveStepsService,userService,inspectionFormService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppGrid: () =>
      import('@/components/common/app.grid.vue'),
    AppDialog: () =>
      import('@/components/common/app.dialog.vue'),
  },
})
export default class VehicleReviveStepsSavePage extends Base {
  public vehicleReviveStepsViewModel: VehicleReviveStepsViewModel = {
    id: 0,
    storeId: 0,
    stepId: '',
    type: '',
    step: 0,
    name: '',
    description: '',
    owners: [],
    hourInStepGreenLimit: 24,
    hourInStepYellowLimit: 48,
    hourInStepRedLimit: 48,
    isDetailROEnabled: false,
    userId: '',
  };
  public disabledPhone: boolean = true;
  public form: any = {};
  public vehicleStepFields: Array<VFields<any>> = [];
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public vehicleType: string = '';
  public reconId: string = '';
  public disableSubmitButton: boolean = false;
  public owner: Owners = {
    id: '',
    name: '',
    phoneNumber: '',
    email: '',
    isTextNotificationEnabled: false,
    isEmailNotificationEnabled: false,
  };
  public inspectionForm: StepInspectionForm = {
    id: 0,
    name: '',
    code: '',
    isEditable: false,
  };

  public laborOpCode: LaborOpCodes = {
    operationCode: '',
    description: '',
  };
  public owners: Owners[] = [];
  public users: any[] = [];
  public laborOpCodes: LaborOpCodes[] = [];
  public inspectionForms: StepInspectionForm[] = [];

  public pagedOwners: any[] = [];
  public pagedLaborOpCodes: any[] = [];
  public pagedInspectionForms: any[] = [];

  public flags: any = {
    ownerloading: false,
    laborloading: false,
    inspectionloading: false,
    updating: false,
  };

  public deleteInspectionFormDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('vehicleReviveSteps.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.removeInspectionForm();
    },
  };

  public deleteLaborOpcodeDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('vehicleReviveSteps.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.removeLaborOpCode();
    },
  };

  public deleteOwnerDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('vehicleReviveSteps.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.removeOwner();
    },
  };

  public pagination = new PaginationModel('name');
  public paginationLaborOpcode = new PaginationModel('operationCode');
  public paginationInspectionForm = new PaginationModel('name');

  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.phoneNo'
      ) as string,
      value: 'phoneNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.email'
      ) as string,
      value: 'email',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.phoneNotification'
      ) as string,
      value: 'isTextNotificationEnabled',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.emailNotification'
      ) as string,
      value: 'isEmailNotificationEnabled',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
  public headersLaborOpCode: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addLaborOpCodes.addLaborOpCodeGridHeaders.operationCode'
      ) as string,
      value: 'operationCode',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addLaborOpCodes.addLaborOpCodeGridHeaders.description'
      ) as string,
      value: 'description',
    },
    {
      align: 'left',
      isNotDataProp: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addLaborOpCodes.addLaborOpCodeGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
  public headersInspectionForm: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addInspectionForms.inspectionFormGridHeaders.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addInspectionForms.inspectionFormGridHeaders.code'
      ) as string,
      value: 'code',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.addInspectionForms.inspectionFormGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];

  public actions: any[] = [];

  public actionsLaboutOpCode: any[] = [];
  public actionsInspectionForm: any[] = [];
  public ownerNameToDelete: string;
  public operationCodeToDelete: string;
  public inspectionFormToDelete: number;
  public isAddUpdateButton = true;
  public greenLimitHint =
    (this.$parent.$t(
      'vehicleReviveSteps.addVehcileReviveStep.stepLimit.greenLimitHint'
    ) as string) + this.vehicleReviveStepsViewModel.hourInStepGreenLimit;
  public yellowLimitHint =
    (((this.$parent.$t(
      'vehicleReviveSteps.addVehcileReviveStep.stepLimit.yellowLimtHint'
    ) as string) +
      (this.vehicleReviveStepsViewModel.hourInStepGreenLimit + 1) +
      this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.stepLimit.to'
      )) as string) + this.vehicleReviveStepsViewModel.hourInStepYellowLimit;
  public redLimitHint =
    (this.$parent.$t(
      'vehicleReviveSteps.addVehcileReviveStep.stepLimit.redLimitHint'
    ) as string) + this.vehicleReviveStepsViewModel.hourInStepRedLimit;
  public panel: any[] = [0, 1, 2, 3]; // [true, true, true, true];
  public isInvalidEmail = false;
  public isInvalidText = false;
  public userList: any[] = [];
  public isLocked: boolean = false;

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-edit',
        title: this.$t(
          'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.gridAction.editOwner'
        ) as string,
        action: (model: Owners, storeid: string) => {
          this.flags.updating = true;
          this.owner = Object.assign({}, model);
          this.updatePrepare();
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'vehicleReviveSteps.addVehcileReviveStep.addOwners.addOwnerGridHeaders.gridAction.deleteOwner'
        ) as string,
        color: 'red',
        action: (model: Owners) => {
          this.confirmDelete(model.id);
        },
      },
    ];
  }

  public setActionsLaboutOpCode() {
    this.actionsLaboutOpCode = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'vehicleReviveSteps.addVehcileReviveStep.addLaborOpCodes.addLaborOpCodeGridHeaders.gridAction.delete'
        ) as string,
        color: 'red',
        action: (model: LaborOpCodes) => {
          this.confirmLaborOpcodeDelete(model.operationCode);
        },
      },
    ];
  }

  public setActionsInspectionForm() {
    this.actionsInspectionForm = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'vehicleReviveSteps.addVehcileReviveStep.addInspectionForms.inspectionFormGridHeaders.gridAction.delete'
        ) as string,
        color: 'red',
        action: (model: StepInspectionForm) => {
          this.confirmInspectionFormDelete(model.id);
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.vehiclerevivesteps.list',
        params: {
          storeId: this.storeId.toString(),
          vehicleType: this.vehicleType.toString(),
        },
      });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('vehicleReviveSteps.addVehcileReviveStep.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
      if (
        !(this.pagedOwners.length > 0) ||
        !this.isAddUpdateButton ||
        !this.vehicleReviveStepsViewModel.hourInStepGreenLimit ||
        !this.vehicleReviveStepsViewModel.hourInStepYellowLimit ||
        !this.vehicleReviveStepsViewModel.hourInStepRedLimit ||
        this.disableSubmitButton
      ) {
        this.showAlert(
          false,
          this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.alertRedGreenYellowLimitRequired'
          )
        );
        this.resetMethodName(methodName);
        return;
      }
      this.submitVehicleReviveStep();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('vehicleReviveSteps.addVehcileReviveStep.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('vehicleReviveSteps.addVehcileReviveStep.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vehicleReviveSteps');
    
    this.vehicleStepFields = [];
    this.setFields();
    this.setActions();
    this.setActionsLaboutOpCode();
    this.setActionsInspectionForm();

    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    }
    if (this.$route.params.vehicleType) {
      this.vehicleReviveStepsViewModel.type = this.$route.params.vehicleType;
    }
    if (this.$route.params.id) {
      this.reconId = this.$route.params.id;
    }
    if (this.$route.params.vehicleType) {
      this.vehicleType = this.$route.params.vehicleType;
    }

    if (this.$route.params.isLocked) {
      this.isLocked = Boolean(this.$route.params.isLocked);
    }

    // Default value for step limit
    this.vehicleReviveStepsViewModel.hourInStepGreenLimit = 24;
    this.vehicleReviveStepsViewModel.hourInStepYellowLimit = 48;
    this.vehicleReviveStepsViewModel.hourInStepRedLimit = 48;

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.getVehicleReviveUsersWithServiceWriter();
    this.getInspectionForms();
    this.getLaborOpCodesWithVehicleReviveStepsById();
  }

  public setFields() {
    this.vehicleStepFields = [
      {
        key: 'type',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: true,
          label: this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.lblVehicleType'
          ) as string,
          items: [
            { key: '0', value: 'New' },
            { key: '1', value: 'Used' },
          ], // [ 'New', 'Used' ]
          text: 'value',
          value: 'key',
          required: true,
          altag: 'Vehicle Type',
          rules:[
            v => this.required('Vehicle Type',v)

          ]
        },
      },
      {
        key: 'step',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 3,
          label: this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.lblstep'
          ) as string,
          required: true,
          type: 'text',
          mask: '###',
          disabled: this.isLocked,
          rules:[
            v => this.required('Step',v)

          ]
        },
      },
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.lblname'
          ) as string,
          required: true,
          disabled: false,
          rules:[
            v => this.required('Name',v)

          ]
        },
      },
      {
        key: 'description',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
          counter: 250,
          label: this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.lbldescription'
          ) as string,
          required: false,
          disabled: false,
        },
      },
      {
        key: 'userId',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          label: this.$t(
            'vehicleReviveSteps.addVehcileReviveStep.lblselectUser'
          ) as string,
          multiple: false,
          required: true,
          items: this.userList,
          text: 'text',
          value: 'id',
          disabled: false,
          altag: 'Select User (Service WriterId for creating detailed RO)',
          rules:[
            v => this.required('Select User(Service WriterId for creating detail Ro)',v)
          ]
        },
      },
    ];
  }

  public async getLaborOpCodesWithVehicleReviveStepsById(): Promise<void> {
    try {
      this.flags.ownerloading = true;
      this.flags.inspectionloading = true;
      this.flags.laborloading = true;
      this.formlyShowSkeleton(this.vehicleStepFields);
      const id = Number(this.$route.params.id)
        ? Number(this.$route.params.id)
        : 0;
      const resp = await vehicleReviveStepsService.getLaborOpCodesWithVehicleReviveStepsById(
        id,
        this.storeId,
        this.$route.params.stepId
      );
      if (resp.vehicleReviveStepsByIdResponse && this.$route.params.id) {
        this.vehicleReviveStepsViewModel = resp.vehicleReviveStepsByIdResponse;

        this.vehicleReviveStepsViewModel.type =
          this.vehicleReviveStepsViewModel.type === 'New' ? '0' : '1';
        const owners = this.vehicleReviveStepsViewModel.owners;
        this.pagedOwners = owners;

        const laborOpCodes = this.vehicleReviveStepsViewModel.laborOpCodes;

        this.pagedLaborOpCodes = laborOpCodes;

        const inspections = this.vehicleReviveStepsViewModel.inspectionForms;
        this.pagedInspectionForms = inspections;

        this.updateHint();
        // removing the selected owners from the user list
        if (this.users.length > 0 && this.pagedOwners.length > 0) {
          this.pagedOwners.forEach(this.removeUsers);
        }

        // removing the selected laborOpCodes from the laborOpCodes list
        if (this.laborOpCodes.length > 0 && this.pagedLaborOpCodes.length > 0) {
          this.pagedLaborOpCodes.forEach(this.removeLaborOpCodes);
        }

        // removing the selected inspection form from the inspections form list
        if (
          this.inspectionForms.length > 0 &&
          this.pagedInspectionForms.length > 0
        ) {
          this.pagedInspectionForms.forEach(this.removeInspectionForms);
        }
      }

      this.laborOpCodes = resp.laborOpCodesResponse.results;
      // removing the selected removeLaborOpCode from the removeLaborOpCodes list
      if (this.pagedLaborOpCodes.length > 0 && this.laborOpCodes.length > 0) {
        this.pagedLaborOpCodes.forEach(this.removeLaborOpCodes);
      }
    } finally {
      this.flags.ownerloading = false;
      this.flags.inspectionloading = false;
      this.flags.laborloading = false;
      this.formlyHideSkeleton(this.vehicleStepFields);
    }
  }

  public async getVehicleReviveUsersWithServiceWriter(): Promise<void> {
    const response = await userService.getVehicleReviveUsersWithServiceWriter(
      this.storeId
    );
    this.users = response.vehicleReviveUsersResponse.results;
    // removing the selected owners from the user list
    if (this.pagedOwners.length > 0 && this.users.length > 0) {
      this.pagedOwners.forEach(this.removeUsers);
    }

    this.userList = response.usersWithServiceWriterIdResponse.results;
    this.setFields();
  }

  public async getInspectionForms(): Promise<void> {
    const res = await inspectionFormService.getInspectionFormSelectListByType(
      this.storeId,
      this.vehicleReviveStepsViewModel.type
    );
    this.inspectionForms = res;
    if (
      this.pagedInspectionForms.length > 0 &&
      this.inspectionForms.length > 0
    ) {
      this.pagedInspectionForms.forEach(this.removeInspectionForms);
    }
  }

  public removeUsers(item, index) {
    const owner = this.users.find((m) => {
      return m.id === item.id;
    });

    if (owner) {
      const userIndex = this.users.indexOf(owner);
      if (userIndex > -1) {
        this.users.splice(userIndex, 1);
      }
    }
  }

  public removeLaborOpCodes(item, index) {
    const laborOpCode = this.laborOpCodes.find((m) => {
      return m.operationCode === item.operationCode;
    });

    if (laborOpCode) {
      const laborOpCodeIndex = this.laborOpCodes.indexOf(laborOpCode);
      if (laborOpCodeIndex > -1) {
        this.laborOpCodes.splice(laborOpCodeIndex, 1);
      }
    }
  }

  public removeInspectionForms(item, index) {
    const inspection = this.inspectionForms.find((m) => {
      return m.id === item.id;
    });

    if (inspection) {
      const inspectionIndex = this.inspectionForms.indexOf(inspection);
      if (inspectionIndex > -1) {
        this.inspectionForms.splice(inspectionIndex, 1);
      }
    }
  }

  public validateVehicleReviveSteps(): Vue & { validate: () => boolean } {
    return this.$refs.vehicleReviveStepsForm as Vue & { validate: () => boolean };
  }

  public async submitVehicleReviveStep(): Promise<void> {
    if(this.validateVehicleReviveSteps().validate()){
      if (!this.vehicleReviveStepsViewModel.userId) {
        // this.showAlert(
        //   false,
        //   this.$t('vehicleReviveSteps.addVehcileReviveStep.alertPleaseSelectUser')
        // );
        return;
      }
      if(this.pagedOwners.length == 0){
        this.showAlert(false,'Please add Owners');
        return;
      }
      if(!this.vehicleReviveStepsViewModel.hourInStepGreenLimit){
        this.showAlert(false,'Please add Green Hours Limit');
        return;
      }
    
      this.isAddUpdateButton = false;
      this.vehicleReviveStepsViewModel.storeId = this.storeId;
      this.vehicleReviveStepsViewModel.owners = this.pagedOwners;
      this.vehicleReviveStepsViewModel.laborOpCodes = this.pagedLaborOpCodes;
      this.vehicleReviveStepsViewModel.inspectionForms = this.pagedInspectionForms;
      if (this.$route.params.id) {
        try {
          this.disableSubmitButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
          this.vehicleReviveStepsViewModel.id = Number(this.$route.params.id);
          await vehicleReviveStepsService.updateSteps(
            this.vehicleReviveStepsViewModel.id,
            this.storeId,
            this.vehicleReviveStepsViewModel
          );
          this.showAlert(
            true,
            this.$t(
              'vehicleReviveSteps.addVehcileReviveStep.alertUpdateVehicleReviveStep'
            )
          );
          this.$router.push({
            name: 'admin.vehiclerevivesteps.list',
            params: {
              storeId: this.storeId.toString(),
              vehicleType: this.vehicleReviveStepsViewModel.type.toString(),
            },
          });
          this.isAddUpdateButton = true;
        } finally {
          this.isAddUpdateButton = true;
          this.disableSubmitButton = false;
          this.$emit('update:progress', this.disableSubmitButton);
        }
      } else {
        try {
          this.disableSubmitButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
          this.vehicleReviveStepsViewModel.id = Number(
            this.$route.params.reconId
          );
          await vehicleReviveStepsService.saveSteps(
            this.storeId,
            this.vehicleReviveStepsViewModel
          );
          this.showAlert(
            true,
            this.$t(
              'vehicleReviveSteps.addVehcileReviveStep.alertSaveVehicleReviveStep'
            )
          );
          this.$router.push({
            name: 'admin.vehiclerevivesteps.list',
            params: {
              storeId: this.storeId.toString(),
              vehicleType: this.vehicleReviveStepsViewModel.type.toString(),
            },
          });
          this.isAddUpdateButton = true;
        } finally {
          this.isAddUpdateButton = true;
          this.disableSubmitButton = false;
          this.$emit('update:progress', this.disableSubmitButton);
        }
      }
    }
  }

  // Owner Section
  public async addOwner(): Promise<void> {
    if (!(await this.validateFormByScope('ownerItems'))) {
      return;
    }
    if(!this.owner.name){
      return;
    }
    if(!(this.owner.isTextNotificationEnabled || this.owner.isEmailNotificationEnabled)){
      this.showAlert(false,'Please select atleast one Notification');
      return;
    }
      if (this.owner.phoneNumber.length === 10) {
        this.owner.phoneNumber =
          '+' + this.owner.phonePrefix + this.owner.phoneNumber;
      }
      const owner = Object.assign({}, this.owner);
      this.pagedOwners.push(owner);

      // removing the added user from user list
      const userowner = this.users.find((m) => {
        return m.id === owner.id;
      });
      const index = this.users.indexOf(userowner);
      if (index > -1) {
        this.users.splice(index, 1);
      }
    this.clearOwner();
  }

  public updatePrepare(): void {
    // insert the owner inside the users list temporary
    const owner = this.pagedOwners.find((m) => {
      return m.id === this.owner.id;
    });
    if (owner) {
      const index = this.users.indexOf(owner);
      if (index === -1) {
        const addOwner = Object.assign({}, this.owner);
        this.users.push(addOwner);

        // prefix change
        this.disabledPhone = true;
        if (this.owner.phoneNumber.length >= 10) {
          this.owner.phoneNumber = this.owner.phoneNumber.replace('+', '');
          const phone = this.owner.phoneNumber;
          this.owner.phoneNumber = phone.substring(
            phone.length,
            phone.length - 10
          );
          this.owner.phonePrefix = phone.substring(phone.length - 10, 0);
          if (!this.owner.phonePrefix) {
            this.owner.phonePrefix = '1';
          }
          this.disabledPhone = this.owner.phonePrefix === '1';
        } else {
          this.owner.phonePrefix = '1';
        }
      }
    }
  }

  public updateOwner(): void {
    if (this.owner.phoneNumber.length === 10) {
      this.owner.phoneNumber =
        '+' + this.owner.phonePrefix + this.owner.phoneNumber;
    }
    const owner = this.pagedOwners.find((m) => {
      return m.id === this.owner.id;
    });
    if (owner) {
      const ownerIndex = this.pagedOwners.indexOf(owner);
      if (ownerIndex > -1) {
        this.pagedOwners.splice(ownerIndex, 1);
      }
    }

    const addOwner = Object.assign({}, this.owner);
    this.pagedOwners.push(addOwner);

    // remove the owner that was added into the users list temporarily
    const userowner = this.users.find((m) => {
      return m.id === this.owner.id;
    });
    const userIndex = this.users.indexOf(userowner);
    if (userIndex > -1) {
      this.users.splice(userIndex, 1);
    }

    this.flags.updating = false;
    this.clearOwner();
  }

  public updateCancel(): void {
    // remove the owner that was added into the users list temporarily
    const userowner = this.users.find((m) => {
      return m.id === this.owner.id;
    });
    const index = this.users.indexOf(userowner);
    if (index > -1) {
      this.users.splice(index, 1);
    }

    this.flags.updating = false;
    this.clearOwner();
  }

  public clearOwner() {
    this.owner.id = '';
    this.owner.name = '';
    this.owner.phoneNumber = '';
    this.owner.email = '';
    this.owner.phonePrefix = '1';
    this.owner.isTextNotificationEnabled = false;
    this.owner.isEmailNotificationEnabled = false;
    this.$validator.reset();
  }

  public confirmDelete(id: string): void {
    this.deleteOwnerDialog.model = true;
    this.ownerNameToDelete = id;
  }

  public removeOwner(): void {
    const owner = this.pagedOwners.find((m) => {
      return m.id === this.ownerNameToDelete;
    });
    if (owner) {
      const index = this.pagedOwners.indexOf(owner);
      if (index > -1) {
        // adding the user back to user list.
        this.users.push(owner);

        this.pagedOwners.splice(index, 1);
        this.ownerNameToDelete = '';
        this.deleteOwnerDialog.model = false;
      }
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public updatePagingLaborOpCode(paging: any) {
    this.paginationLaborOpcode = paging;
  }

  public updatePagingInspectionForm(paging: any) {
    this.paginationInspectionForm = paging;
  }

  public getSelectedOwner(value) {
    const user = this.users.find((x) => x.id === value);
    this.owner.name = user.name;
    this.owner.email = user.email;
    this.owner.id = user.id;
    this.owner.isEmailNotificationEnabled = false;
    this.owner.isTextNotificationEnabled = false;
    this.owner.phonePrefix = '1';
  }

  public validateEmail(email) {
    this.isInvalidEmail = false;
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (
      re.test(String(email).toLowerCase()) || this.disableEmailNotification()
    );
  }

  public disableEmailNotification() {
    this.owner.isEmailNotificationEnabled = false;
    this.isInvalidEmail = true;
    return 'Invalid e-mail.';
  }

  public emailNotification(email) {
    if (this.owner.isEmailNotificationEnabled === undefined) {
      this.owner.isEmailNotificationEnabled = false;
    }
    return email ? '' : (this.owner.isEmailNotificationEnabled = false);
  }
  public phoneNotification(phone) {
    this.isInvalidText = false;

    if (this.owner.isTextNotificationEnabled === undefined) {
      this.owner.isTextNotificationEnabled = false;
    }
    return phone && phone.length === 10
      ? ''
      : (this.isInvalidText = !(this.owner.isTextNotificationEnabled = false));
  }

  // laborOpcode Section
  public getSelectedLaborOpCode(value) {
    this.laborOpCode = Object.assign(
      {},
      this.laborOpCodes.find((x) => x.operationCode === value)
    );
  }

  public async addLaborOpcode(): Promise<void> {
    if (!(await this.validateFormByScope('laborOpCodeItems'))) {
      return;
    }
    if(!this.laborOpCode.operationCode){
      return;
    }
    const laborOpCode = Object.assign({}, this.laborOpCode);
    this.pagedLaborOpCodes.push(laborOpCode);

    // removing the added laborOpCode from laborOpCodes list
    const laborOpCodesItem = this.laborOpCodes.find((m) => {
      return m.operationCode === laborOpCode.operationCode;
    });
    const index = this.laborOpCodes.indexOf(laborOpCodesItem);
    if (index > -1) {
      this.laborOpCodes.splice(index, 1);
    }
    this.clearLaborOpcode();
  }

  public clearLaborOpcode() {
    this.laborOpCode.operationCode = '';
    this.laborOpCode.description = '';
    this.$validator.reset();
  }
  public confirmLaborOpcodeDelete(operationCode: string): void {
    this.deleteLaborOpcodeDialog.model = true;
    this.operationCodeToDelete = operationCode;
  }
  public removeLaborOpCode(): void {
    const laborOpCode = this.pagedLaborOpCodes.find((m) => {
      return m.operationCode === this.operationCodeToDelete;
    });
    if (laborOpCode) {
      const index = this.pagedLaborOpCodes.indexOf(laborOpCode);
      if (index > -1) {
        // adding the laborOpCode back to laborOpCodes list.
        this.laborOpCodes.push(laborOpCode);

        this.pagedLaborOpCodes.splice(index, 1);
        this.operationCodeToDelete = '';
        this.deleteLaborOpcodeDialog.model = false;
      }
    }
  }

  public validateYellowLimitRule(yellowLimit) {
    this.updateRedLimit(yellowLimit);
    return (
      (yellowLimit &&
        yellowLimit > this.vehicleReviveStepsViewModel.hourInStepGreenLimit) ||
      'Yellow Limit must be greater than Green Limit'
    );
  }
  public updateRedLimit(yellowLimit) {
    this.vehicleReviveStepsViewModel.hourInStepRedLimit = yellowLimit;
    this.updateHint();
  }

  public updateHint() {
    this.greenLimitHint =
      (this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.stepLimit.greenLimitHint'
      ) as string) + this.vehicleReviveStepsViewModel.hourInStepGreenLimit;
    this.yellowLimitHint =
      (((this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.stepLimit.yellowLimtHint'
      ) as string) +
        (Number(this.vehicleReviveStepsViewModel.hourInStepGreenLimit) + 1) +
        this.$parent.$t(
          'vehicleReviveSteps.addVehcileReviveStep.stepLimit.to'
        )) as string) + this.vehicleReviveStepsViewModel.hourInStepYellowLimit;
    this.redLimitHint =
      (this.$parent.$t(
        'vehicleReviveSteps.addVehcileReviveStep.stepLimit.redLimitHint'
      ) as string) + this.vehicleReviveStepsViewModel.hourInStepRedLimit;
  }

  // inspection Section
  public getSelectedInspectionForm(value) {
    this.inspectionForm = Object.assign(
      {},
      this.inspectionForms.find((x) => x.id === value)
    );
  }

  public addInspectionForm(): void {
    if(!this.inspectionForm.name){
      this.showAlert(false, 'Please Add Inspection Forms');
      return;
    }
    const inspection = Object.assign({}, this.inspectionForm);
    this.pagedInspectionForms.push(inspection);

    // removing the added laborOpCode from laborOpCodes list
    const inspectionFormsItem = this.inspectionForms.find((m) => {
      return m.id === inspection.id;
    });
    const index = this.inspectionForms.indexOf(inspectionFormsItem);
    if (index > -1) {
      this.inspectionForms.splice(index, 1);
    }
    this.clearInspectionForm();
  }

  public clearInspectionForm() {
    this.inspectionForm.id = 0;
    this.inspectionForm.name = '';
    this.inspectionForm.code = '';
  }
  public confirmInspectionFormDelete(id: number): void {
    this.deleteInspectionFormDialog.model = true;
    this.inspectionFormToDelete = id;
  }

  public removeInspectionForm(): void {
    const inspection = this.pagedInspectionForms.find((m) => {
      return m.id === this.inspectionFormToDelete;
    });
    if (inspection) {
      const index = this.pagedInspectionForms.indexOf(inspection);
      if (index > -1) {
        // adding the inspectionForm back to inspectionForm list.
        this.inspectionForms.push(inspection);

        this.pagedInspectionForms.splice(index, 1);
        this.inspectionFormToDelete = 0;
        this.deleteInspectionFormDialog.model = false;
      }
    }
  }
}
